import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["flush", "children", "as"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, forwardRef, useState, useContext, useEffect } from 'react';
import Card from 'components/Card';
import useUniqueId from 'hooks/useUniqueId';
import { jsx as _jsx } from "react/jsx-runtime";
export var PanelTitleContext = /*#__PURE__*/createContext(undefined);
export function usePanelTitleId(id) {
  var panelHeadingId = useUniqueId();
  var idToRegister = id || panelHeadingId;
  var setPanelTitleId = useContext(PanelTitleContext);
  useEffect(function () {
    if (setPanelTitleId) {
      setPanelTitleId(idToRegister);
    }
  }, [idToRegister, setPanelTitleId]);
  return idToRegister;
}
var PanelWrapper = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var flush = _ref.flush,
    children = _ref.children,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'section' : _ref$as,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    panelTitleId = _useState2[0],
    setPanelTitleId = _useState2[1];
  return /*#__PURE__*/_jsx(PanelTitleContext.Provider, {
    value: setPanelTitleId,
    children: /*#__PURE__*/_jsx(Card, _objectSpread(_objectSpread({}, otherProps), {}, {
      as: as,
      "aria-labelledby": panelTitleId,
      ref: ref,
      size: "small",
      p: flush ? undefined : 's',
      mb: "xs",
      children: children
    }))
  });
});
PanelWrapper.displayName = 'PanelWrapper';
export default PanelWrapper;